<template>
  <Modal class="scheduler-modal">
    <div class="modal-header scheduler-modal-header">
      <h5>ตั้งเวลาเผยแพร่ไฟล์ {{attachmentToBeScheduled.name}}</h5>
      <button
        type="button"
        class="btn btn-link btm-sm btn-close-container"
        @click.stop="onCloseModal">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <form v-on:submit.prevent="onSubmit">
      <div class="modal-body">
        <FormGroup>
          <h5 class="name">
            <i class="fas fa-play-circle"></i> วันแรกที่เผยแพร่
          </h5>
          <DateTimePicker
            v-model="attachmentToBeScheduled.startPublish"
            placeholder="กรุณาเลือกวันที่" />
        </FormGroup>
        <FormGroup>
          <h5 class="name">
            <i class="fas fa-stop-circle"></i> วันสุดท้ายที่เผยแพร่
          </h5>
          <DateTimePicker
            v-model="attachmentToBeScheduled.endPublish"
            placeholder="กรุณาเลือกวันที่"
            @dateChanged="onDateChanged" />
        </FormGroup>
        <div
          class="alert alert-danger"
          v-if="timeMachine">
          <p>คุณไม่สามารถตั้งวันสิ้นสุดก่อนวันเริ่มต้นได้</p>
        </div>
      </div>
      <div class="modal-footer scheduler-modal-footer">
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="!isValid || timeMachine">
          บันทึก
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';

export default {
  props: {
    attachmentItem: {
      type: Object,
      default: () => {},
    },
    onUpdate: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Modal,
    FormGroup,
    DateTimePicker,
  },
  data() {
    return {
      timeMachine: false,
      attachmentToBeScheduled: {
        name: '',
        startPublish: null,
        endPublish: null,
      },
    };
  },
  computed: {
    isValid() {
      return this.attachmentToBeScheduled.startPublish !== null;
    },
  },
  created() {
    this.attachmentToBeScheduled = _.defaults(_.cloneDeep(this.attachmentItem), _.cloneDeep(this.attachmentToBeScheduled));
  },
  methods: {
    ...mapActions(['setActiveModal']),
    onSubmit() {
      this.onUpdate({ ...this.attachmentItem, ...this.attachmentToBeScheduled });
    },
    onCloseModal() {
      this.setActiveModal(null);
      this.onUpdate({ ...this.attachmentItem, status: 'published' });
    },
    resetDate() {
      this.attachmentToBeScheduled.endPublish = null;
    },
    tryToMakeTimeMachine(startPublish, endPublish) {
      const start = new Date(startPublish).getTime();
      const end = new Date(endPublish).getTime();
      return end < start;
    },
    onDateChanged(pickedDate) {
      if (this.tryToMakeTimeMachine(this.attachmentToBeScheduled.startPublish, pickedDate)) {
        this.timeMachine = true;
        this.resetDate();
      } else {
        this.timeMachine = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.scheduler-modal {
  .form-group:last-child {
    margin-bottom: 0;
  }
  .alert-danger {
    p {
      margin: 0;
    }
  }
}
</style>
